import request from '@/plugin/axios'

export function IndexStat (data) {
  return request({
    url: '/stat/index',
    method: 'get',
    data
  })
}
